import { Accordion, AccordionProps } from 'primereact/accordion';
import React from 'react';
import styled from 'styled-components';

const StyledAccordion = styled(Accordion)`
  &.p-accordion {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: var(--default-padding);
    width: 100%;
    height: auto;

    .p-accordion-tab {
      overflow: hidden;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      padding: var(--big-padding);
      width: 100%;
      position: relative;
      border-radius: var(--medium-border-radius);
      background-color: var(--beige-main);
      .p-accordion-header {
        width: 100%;
        .p-accordion-header-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          color: var(--black-main);
          background-color: var(--beige-main);
          border-radius: var(--medium-border-radius);
          border: none;
          font-weight: normal;
          padding: 0;
          .accordion-header {
            color: var(--black-main);
          }

          &:not(.p-disabled):hover {
            color: var(--black-main);
            background-color: var(--beige-main);
          }
        }

        .p-accordion-toggle-icon {
          color: var(--gray-darker);
          order: 1;
          padding-left: var(--medium-padding);
        }

        &:not(.p-disabled).p-highlight .p-accordion-header-link {
          background-color: var(--beige-main);
          color: var(--black-main);
        }
        &:not(.p-disabled).p-highlight .inactive-product-header {
          visibility: hidden;
        }
        &:not(.p-disabled) .p-accordion-header-link:focus {
          box-shadow: none;
        }
        &:not(.p-disabled).p-highlight:hover {
          .p-accordion-header-link {
            background-color: var(--beige-main);
            border: none;
          }
        }

        &:not(p-disabled):hover {
          color: var(--black-main);
          background-color: var(--beige-main);
          border-radius: var(--medium-border-radius);
        }
      }

      .p-accordion-content {
        background-color: transparent;
        border: none;
        padding: 0;
        color: var(--black-main);
        .p-calendar .p-inputtext:not(.p-dropdown-label) {
          padding-left: var(--xsmall-padding);
        }
      }
      &.p-accordion-header:not(.p-disabled).p-highlight
        .p-accordion-header-link {
        background-color: var(--beige-main);
      }
    }
  }
`;

type AppAccordionPropsType = {
  children: React.ReactNode;
} & AccordionProps;

export const AppAccordion: React.FC<AppAccordionPropsType> = ({
  children,
  ...rest
}) => {
  return (
    <StyledAccordion
      collapseIcon="pi pi-chevron-up"
      expandIcon="pi pi-chevron-down"
      {...rest}
    >
      {children}
    </StyledAccordion>
  );
};
